// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__XvJc6","inputDescription":"styles_inputDescription__2MCy1"};